module.exports = __webpack_public_path__ + "static/media/home-background.fe2283e1.svg";